<template>
    <c-dialog ref="dialog" title="发货详情" mode="slide" width="80vw" enable-flex mask-close :button="false">
        <template #head>
            <div class="m-detail-tag flex-center-cross">
                <span v-if="saasName" class="m-detail-saas">{{saasName}}</span>
            </div>
        </template>

        <div class="m-ship-detail-summary" v-if="deliveryDetail.delivery">
            发货单：{{deliveryDetail.delivery.delivery_no}} 结果：<span :class="deliveryResultClass(deliveryDetail.delivery.delivery_result)">{{deliveryResultText(deliveryDetail.delivery.delivery_result)}}</span>
        </div>
        <c-table :data="deliveryDetail.details" border :paging="false">
            <template #empty>
                <c-empty message="暂无发货明细"></c-empty>
            </template>
            <c-table-column label="订单号" width="130">
                <template #default="{data}">{{data.order_no || '-'}}</template>
            </c-table-column>
            <c-table-column label="商品" width="320" :ellipsis="false">
                <template #default="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                </template>
            </c-table-column>
            <c-table-column label="质检码" width="150">
                <template #default="{data}">{{data.qc_code || '-'}}</template>
            </c-table-column>
            <c-table-column label="发货结果" width="70">
                <template #default="{data}">
                    <span :class="data.ship_result == 1 ? 'm-ship-success' : 'm-ship-fail'">{{data.ship_result == 1 ? '发货成功' : '发货失败'}}</span>
                </template>
            </c-table-column>
            <c-table-column label="失败原因" min-width="200" :ellipsis="false">
                <template #default="{data}">{{data.fail_reason || '-'}}</template>
            </c-table-column>
        </c-table>
    </c-dialog>
</template>

<script>
export default {
    name: 'erpDeliveryDetail',

    data() {
        return {
            saasName: '',
            deliveryDetail: {delivery: null, details: []}
        }
    },

    methods: {
        /*********打开抽屉（data=列表行）**********/
        open(data = {}) {
            this.saasName = data.saas_name || '';
            this.deliveryDetail = {delivery: null, details: []};
            this.$refs.dialog.open();
            this.request({
                url: '/sale/delivery/ops/detail',
                data: {
                    merchant_id: data.saas_id,
                    id: data.id
                },
                loading: true,
                success: data => {
                    this.deliveryDetail = data || {delivery: null, details: []};
                }
            });
        },

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },

        deliveryResultText(result) {
            return {1: '已发货（全部成功）', 2: '已发货（部分成功）', 3: '已关闭（全部失败）'}[result] || '待发货';
        },

        deliveryResultClass(result) {
            return {1: 'm-ship-success', 2: 'm-ship-partial', 3: 'm-ship-fail'}[result] || '';
        }
    }
}
</script>

<style scoped>
.m-detail-tag {
    gap: 8px;
    font-size: 14px;
    font-weight: bold;
}

.m-detail-saas {
    font-size: 12px;
    font-weight: normal;
    color: #999;
}

.m-ship-detail-summary {
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
}

.m-ship-success {
    color: #19be6b;
}

.m-ship-partial {
    color: #ff9900;
}

.m-ship-fail {
    color: #ed3f14;
}
</style>
